import { showToast } from "../../../common/Toaster/Toaster";
import rootReducer from "../../../store";
import { setQualificationData } from "../../../slices/qualification/qualificationsSlice";
import { RenderPage } from "../../../slices/common/reducer";
import api from "../../../Utils/interface";

export const createQualification = async (body) => {
    try {
        const response = await api.post(`/agsp/qualification`, body, {
            headers: { "Content-Type": "application/json" },
        });
        if (response.data && response.status === 200) {
            rootReducer.dispatch(RenderPage());
            const isUpdate = !!(body.id || body.entityid);
            showToast(
                isUpdate ? "Qualification Updated Successfully" : "Qualification Created Successfully",
                "success"
            );
            return response.data;
        }
    } catch (error) {
        console.log("Error", error);
    }
};